import React, { useState } from "react";
import Doc1 from "../assets/doc1.png";
import Doc2 from "../assets/doc2.png";
import Doc3 from "../assets/doc3.png";
import Doc4 from "../assets/doc4.png";
import Doc5 from "../assets/doc5.png";
import Doc6 from "../assets/doc6.png";
import Doc7 from "../assets/doc7.png";
import Doc8 from "../assets/doc8.png";
import Doc9 from "../assets/doc9.png";
import Doc10 from "../assets/doc10.png";

const AshGuide = () => {
  const [selectedModel, setSelectedModel] = useState("Ash-Pro");

  const Search = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
  );

  const FileText = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  );

  const AlertTriangle = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
  );

  const Plus = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
    </svg>
  );

  const MessageSquare = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
      />
    </svg>
  );

  const Upload = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
      />
    </svg>
  );

  const Check = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );

  const Trash2 = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
  );

  const Settings = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );

  const Zap = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 10V3L4 14h7v7l9-11h-7z"
      />
    </svg>
  );

  const Brain = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
      />
    </svg>
  );

  const Crown = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  );

  const Calendar = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );

  const HelpCircle = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );

  const FileSearch = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
      />
    </svg>
  );

  const ChevronRight = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  );

  const X = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );

  const FolderOpen = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"
      />
    </svg>
  );

  const History = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );

  const FileStack = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  );

  const Sparkles = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
      />
    </svg>
  );

  const FileCheck = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );

  const PlusCircle = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );

  const MessageCircle = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
      />
    </svg>
  );

  const ModelCard = ({
    model,
    speed,
    accuracy,
    description,
    icon: Icon,
    color,
    recommended,
  }) => (
    <div
      className={`relative bg-white p-6 rounded-xl border-2 transition-all duration-300 cursor-pointer ${
        selectedModel === model
          ? `border-purple-500 shadow-lg`
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => setSelectedModel(model)}
    >
      {recommended && (
        <div className="absolute -top-3 -right-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs px-3 py-1 rounded-full">
          추천
        </div>
      )}
      <div className="flex items-start gap-4">
        <div
          className={`w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center`}
        >
          <Icon className={`w-6 h-6 text-purple-600`} />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-gray-800 mb-1">{model}</h4>
          <p className="text-sm text-gray-600 mb-3">{description}</p>
          <div className="flex items-center gap-4 text-xs">
            <div className="flex items-center gap-1">
              <span className="text-gray-500">속도:</span>
              <span className="text-gray-700">{speed}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-gray-500">정확도:</span>
              <span className="text-gray-700">{accuracy}</span>
            </div>
          </div>
        </div>
      </div>
      {selectedModel === model && (
        <div
          className={`absolute bottom-2 right-2 w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center`}
        >
          <Check className="w-4 h-4 text-white" />
        </div>
      )}
    </div>
  );

  const DummyImage = ({ title, className = "" }) => (
    <div
      className={`bg-gradient-to-br from-purple-100 to-pink-100 rounded-lg shadow-md flex items-center justify-center p-8 ${className}`}
    >
      <div className="text-center">
        <FileText className="w-16 h-16 text-purple-400 mx-auto mb-3" />
        <p className="text-purple-600 font-medium">{title}</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-600/10 via-pink-600/10 to-purple-600/10"></div>
        <div className="relative container mx-auto px-6">
          <div className="text-center space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 rounded-full text-purple-700 text-sm font-medium">
              <Sparkles className="w-4 h-4" />
              Advanced Document Analysis
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              Ash-Preview001 문서 딥리서치
            </h1>

            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Ash를 통해 다양한 문서를 비교하고 요약하며 심도 깊은 인사이트를
              분석할 수 있는 AI 기반 차세대 문서 질의 응답 시스템입니다.
            </p>
          </div>
        </div>
      </section>

      <section className="py-8 bg-purple-50 border-y border-purple-200">
        <div className="container mx-auto px-6">
          <div className="flex items-start gap-4 max-w-4xl mx-auto">
            <AlertTriangle className="w-6 h-6 text-purple-600 flex-shrink-0 mt-1" />
            <div className="space-y-3">
              <h3 className="font-semibold text-gray-800">
                ⚠️ Preview 버전 안내
              </h3>
              <p className="text-gray-700">
                현재 <strong>Ash-Preview001</strong>은 프리뷰 버전으로 제공되며,
                일부 기능이 제한될 수 있습니다. 정식 버전은 2025년 8월에 출시
                예정입니다.
              </p>
              <div className="flex items-center gap-2 mt-3">
                <Calendar className="w-4 h-4 text-gray-500" />
                <span className="text-sm text-gray-600">
                  정식 버전 출시 예정: 2025년 8월
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Features */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-2xl border border-purple-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <FileStack className="w-5 h-5 text-purple-600" />
                Ash 딥리서치의 3가지 핵심 기능
              </h3>
              <div className="grid md:grid-cols-3 gap-4">
                <div className="bg-white p-4 rounded-lg border border-purple-100">
                  <FolderOpen className="w-8 h-8 text-purple-600 mb-2" />
                  <h4 className="font-semibold text-gray-800 mb-1">
                    파일 관리하기
                  </h4>
                  <p className="text-sm text-gray-600">
                    지식기반 질의응답이 필요한 문서들을 업로드하고 관리합니다.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg border border-purple-100">
                  <MessageCircle className="w-8 h-8 text-purple-600 mb-2" />
                  <h4 className="font-semibold text-gray-800 mb-1">
                    문서 질의응답하기
                  </h4>
                  <p className="text-sm text-gray-600">
                    업로드한 문서들 중 분석할 문서들을 선택하여 질문합니다.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg border border-purple-100">
                  <History className="w-8 h-8 text-purple-600 mb-2" />
                  <h4 className="font-semibold text-gray-800 mb-1">
                    히스토리 보기
                  </h4>
                  <p className="text-sm text-gray-600">
                    과거 분석 내용들을 다시 볼 수 있습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Step by Step Guide */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            <h2 className="text-3xl font-bold text-center text-gray-800">
              사용 가이드
            </h2>

            {/* 큰 주제 1: 파일 관리하기 */}
            <div className="space-y-8">
              <h3 className="text-2xl font-bold text-purple-600 flex items-center gap-2">
                <FolderOpen className="w-6 h-6" />
                파일 관리하기
              </h3>

              {/* Step 1 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">1</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    딥리서치 메인 화면
                  </h4>
                </div>
                {/* <DummyImage title="딥리서치 메인 화면" className="h-64" /> */}
                <img src={Doc1} alt="설명이미지" />
                <p className="bg-purple-50 border-l-4 border-purple-500 p-4 rounded-md shadow-sm text-gray-800 leading-relaxed">
                  딥리서치에는 <span className="font-semibold">3가지 섹션</span>
                  이 존재합니다.
                  <br />•{" "}
                  <span className="text-purple-600 font-medium">
                    파일 관리하기
                  </span>{" "}
                  - 지식기반 질의응답이 필요한 문서들을 업로드합니다.
                  <br />•{" "}
                  <span className="text-purple-600 font-medium">
                    문서 질의응답하기
                  </span>{" "}
                  - 업로드한 문서들 중 분석할 문서들을 선택하여 질문합니다.
                  <br />•{" "}
                  <span className="text-purple-600 font-medium">
                    히스토리 보기
                  </span>{" "}
                  - 과거 분석 내용들을 다시 볼 수 있습니다.
                </p>
              </div>

              {/* Step 2 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">2</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    파일 관리 화면
                  </h4>
                </div>
                <img src={Doc2} alt="설명이미지" />
                <p className="text-gray-600">
                  파일관리하기를 들어가면 해당 화면이 뜨며, 여기서 파일 삭제
                  업로드 등을 관리할 수 있습니다.
                </p>
              </div>

              {/* Step 3 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">3</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    파일 삭제
                  </h4>
                </div>
                <img src={Doc3} alt="설명이미지" />
                <div className="flex items-center gap-3 p-4 bg-red-50 rounded-lg border border-red-200">
                  <Trash2 className="w-5 h-5 text-red-600" />
                  <p className="text-gray-700">
                    삭제의 경우 파일을 선택하시면 해당 파일을 삭제할 수
                    있습니다.
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">4</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    파일 업로드
                  </h4>
                </div>
                <img src={Doc4} alt="설명이미지" />
                <div className="flex items-center gap-3 p-4 bg-green-50 rounded-lg border border-green-200">
                  <Upload className="w-5 h-5 text-green-600" />
                  <p className="text-gray-700">
                    업로드의 경우 해당 버튼을 클릭하면 로컬에 있는 파일을 업로드
                    할 수 있습니다.
                  </p>
                </div>
              </div>
            </div>

            {/* 큰 주제 2: 문서 질의응답하기 */}
            <div className="space-y-8 mt-16">
              <h3 className="text-2xl font-bold text-purple-600 flex items-center gap-2">
                <MessageCircle className="w-6 h-6" />
                문서 질의응답하기
              </h3>

              {/* Step 5 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">5</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    질문 방식 선택
                  </h4>
                </div>
                <img src={Doc5} alt="설명이미지" />
                <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5" />
                    <div>
                      <p className="text-gray-700">
                        질문방식은 지속적인 채팅과 한 번에 질문하기가 있으나
                        <span className="font-semibold">
                          {" "}
                          현재로서는 1회성 질문만 가능한 상태입니다.
                        </span>{" "}
                        (서버이슈)
                      </p>
                      <p className="text-gray-600 text-sm mt-2">
                        주제 입력은 과거 문서 기록을 보기 위해 사용자 편의성을
                        위한 제목입니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 6 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">6</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    문서 선택 및 시작
                  </h4>
                </div>
                <img src={Doc6} alt="설명이미지" />
                <p className="text-gray-600">
                  현재로서는 한 번에{" "}
                  <span className="font-semibold text-purple-600">
                    30MB 파일
                  </span>
                  까지 업로드가 가능하며 사진과 같이 분석할 문서들을 체크하여
                  채팅 시작을 눌러주시면 됩니다.
                </p>
              </div>

              {/* Step 7 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">7</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    질의응답 시작
                  </h4>
                </div>
                <img src={Doc7} alt="설명이미지" />
                <p className="text-gray-600">
                  시작을 누르시면 해당 페이지로 이동하게 되며, 한 번 진행되는
                  대화이지만
                  <span className="font-semibold text-purple-600">
                    {" "}
                    여러 개의 질문이 가능합니다.
                  </span>
                </p>
              </div>

              {/* Step 8 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">8</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    다중 질문 추가
                  </h4>
                </div>
                <img src={Doc8} alt="설명이미지" />
                <div className="flex items-center gap-3 p-4 bg-purple-50 rounded-lg border border-purple-200">
                  <PlusCircle className="w-5 h-5 text-purple-600" />
                  <p className="text-gray-700">
                    이렇게 질문추가 버튼을 눌러 여러 쌍의 질문을 시도할 수
                    있습니다.
                  </p>
                </div>
              </div>

              {/* Step 9 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">9</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    Ash의 종합 답변
                  </h4>
                </div>
                <img src={Doc9} alt="설명이미지" />
                <div className="mt-4 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg border border-purple-200">
                  <div className="flex items-start gap-3">
                    <Sparkles className="w-5 h-5 text-purple-600 mt-0.5" />
                    <div>
                      <p className="font-medium text-gray-800">
                        Ash의 딥 리서치
                      </p>
                      <p className="text-sm text-gray-600 mt-1">
                        위 사진과 같이 여러 문제에 대한 답변을 Ash가 정리하여
                        전달해줍니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 큰 주제 3: 분석 히스토리 */}
            <div className="space-y-8 mt-16">
              <h3 className="text-2xl font-bold text-purple-600 flex items-center gap-2">
                <History className="w-6 h-6" />
                분석 히스토리
              </h3>

              {/* Step 10 */}
              <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <span className="text-purple-600 font-bold">10</span>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-800">
                    히스토리 보기
                  </h4>
                </div>
                <img src={Doc10} alt="설명이미지" />
                <p className="text-gray-600">
                  해당 탭에서는 사용자가 질문한 히스토리를 누르면
                  <span className="font-semibold text-purple-600">
                    {" "}
                    어떤 답변을 받았었고, 당시에 어떤 파일을 썼고 질문이 어떤
                    질문이었는지
                  </span>{" "}
                  한 눈에 확인할 수 있습니다.
                </p>
                <div className="grid md:grid-cols-3 gap-4 mt-4">
                  <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
                    <FileCheck className="w-5 h-5 text-purple-600" />
                    <span className="text-gray-700">사용된 파일</span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-pink-50 rounded-lg">
                    <MessageSquare className="w-5 h-5 text-pink-600" />
                    <span className="text-gray-700">질문 내역</span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-purple-50 rounded-lg">
                    <FileText className="w-5 h-5 text-purple-600" />
                    <span className="text-gray-700">답변 내용</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AshGuide;
